import http from '../../../utils/http';
import security from '../../../utils/security';
import moment from 'moment'
import {
  REPORT_INVOICE_ERROR,
  REPORT_INVOICE_LOADING,
  REPORT_INVOICE_RESET,
  REPORT_INVOICE_SUCCESS,
} from './mutation-types';

const state = {
  loading: false,
  error: '',
  items: [],
};

function error(error) {
  return {type: REPORT_INVOICE_ERROR, error};
}

function loading(loading) {
  return {type: REPORT_INVOICE_LOADING, loading};
}

function success(items) {
  return {type: REPORT_INVOICE_SUCCESS, items};
}

const getters = {
  error: state => state.error,
  items: state => state.items,
  loading: state => state.loading,
};

const actions = {
  getItems({ commit }, {currency, from, to}) {
    commit(loading(true));
    commit(error(null));
    to =  moment(to).format('YYYY-MM-DD')
    from =  moment(from).format('YYYY-MM-DD')
    return http.fetch('/reports/invoice/' + currency.id + '?from=' + from +'&to=' + to)
      .then(response => response.json())
      .then(data => {
        commit(loading(false));
        commit(success(data));
      })
      .catch(e => {
        commit(loading(false));
        if(security.handleAuthorizationError(e)){
          return;
        }
        commit(error(e.message));
      });
  }
};

const mutations = {
  [REPORT_INVOICE_ERROR] (state, payload) {
    state.error = payload.error;
  },
  [REPORT_INVOICE_LOADING] (state, payload) {
    state.loading = payload.loading;
  },
  [REPORT_INVOICE_SUCCESS] (state, payload) {
    state.items = payload.items;
  },
  [REPORT_INVOICE_RESET] (state) {
    state.items = [];
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/report/invoice.js